import { NoddiIcon } from 'noddi-ui-common';

type Props = {
  errorMessage: string;
  id?: string;
};

export const FieldErrorMessage = ({ errorMessage, id }: Props) => {
  return (
    // No role='alert': controls reference this via aria-describedby, so an assertive live region
    // would announce every field twice and interrupt on multi-field submits.
    <div id={id} className='flex items-baseline gap-1 text-dangerDark'>
      <span aria-hidden='true'>
        <NoddiIcon name='CircleX' size='xSmall' />
      </span>
      <span className='text-sm'>{errorMessage}</span>
    </div>
  );
};
